export enum AlertType {
  GLOBAL = 1,
  CARRIER = 2,
  PRODUCT = 3,
  FI = 4
}

export enum AlertSeverity {
  INFO = 1,
  WARNING = 2,
  CRITICAL = 3
}

export interface AppAlert {
  alertId: number;
  alertType: AlertType;
  severity: AlertSeverity;
  title: string;
  message: string;
  carrierName: string;
  product: string;
  fiName: string;
  startDate: string;
  endDate: string | null;
}

export interface AlertResponse {
  alertList: AppAlert[];
}
